import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { RCUtils } from './../../../RCUtils';
import $ from 'jquery';
import { PopupWindow } from '../PopupWindow';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface MSCGridState {
    SelectedReefers: any[],
    RowData: server.USP_UnitCurrentConditionUI_Model[],
    Filters: server.MSCParams,
    ForwardCommandParms: server.ForwardCommandParams;
    cssONOFFClass: string
    cssHumidityClass: string
    cssPoint2Class: string
    VisibleHumidity1: string;
    VisibleHumidity2: string;
    VisibleHumidity3: string;
    VCCheckBoxInfo: VCCheckBoxData;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}
var self;
var MSCDurationInitialText;
var MSCDuration1Text;
var MSCDuration2Text;
export class MultipleSetpoints extends React.Component<any, MSCGridState> {
    constructor(props: any) {
        super(props);
        self = this;
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        var forwardCommandParms: server.ForwardCommandParams = { SelectedReefers: [], CommandName: null, TempValue: null, PreTripCmdFilters: null, TraditionalDownload: null, lstAutoConfigParams: null, IsCmdSendViaVC: null, VesselInfo: null };
        this.state = { SelectedReefers: [], RowData: [], Filters: filterSet, ForwardCommandParms: forwardCommandParms, cssONOFFClass: 'd-block', cssHumidityClass: 'd-block', cssPoint2Class: 'd-none', VisibleHumidity1: 'd-none', VisibleHumidity2: 'd-none', VisibleHumidity3: 'd-none', VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [] };
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderMSCGrid(this.props.reeferData);
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        $('#globalLoader').hide();
    }

    componentWillReceiveProps(nextprops: any) {
        this.setState({ SelectedReefers: reeferData });
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderMSCGrid(reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }

        var filters = this.state.Filters;
        if (this.state.Filters.MSCTurnONoFF == "OFF") {
            this.state.Filters.MSCTurnONoFF = "ON";
            this.setState({ Filters: filters });
            this.setState({ cssONOFFClass: 'd-block' });
        }
    }

    renderMSCGrid(reeferData: any) {
        this.setState({ SelectedReefers: reeferData });
        var filterSet = this.setDefaultFilters();
        this.setState({ Filters: filterSet });
        this.state.ForwardCommandParms.CommandName = "MultipleSetpointChange";
        this.state.ForwardCommandParms.SelectedReefers = reeferData;
        this.setState({ RowData: reeferData });
        var forwardCommandParams = JSON.stringify(this.state.ForwardCommandParms);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
        var reeferOEMTypeCd = reeferData[0].ReeferOEMTypeCd.trim();

        if (reeferOEMTypeCd == "S") {
            MSCDurationInitialText = "Initial MSC Duration (hour(s)) :";
            MSCDuration1Text = "MSC Duration 1 (hour(s)) :";
            MSCDuration2Text = "MSC Duration 2 (hour(s)) :";
            this.setState({ VisibleHumidity1: 'row', VisibleHumidity2: 'row', VisibleHumidity3: 'row' });

        }
        else if (reeferOEMTypeCd == "C") {
            MSCDurationInitialText = "Initial MSC Duration (day(s)) :";
            MSCDuration1Text = "MSC Duration 1 (day(s)) :";
            MSCDuration2Text = "MSC Duration 2 (day(s)) :";
            this.setState({ VisibleHumidity1: 'd-none', VisibleHumidity2: 'd-none', VisibleHumidity3: 'd-none' });

        }
    }

    StatusONOFFChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value.trim();
        var filters = this.state.Filters;
        if (Value == 'ON') {
            this.setState({ cssONOFFClass: 'd-block' })
        }
        else {
            this.setState({ cssONOFFClass: 'd-none' })

        }

        this.state.Filters.MSCTurnONoFF = Value;
        this.setState({ Filters: filters });
    }

    StatusMSCSetsChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value.trim();
        var filters = this.state.Filters;
        if (Value == '1') {
            this.setState({ cssPoint2Class: 'd-none' })
            this.state.Filters.InitialTemp = '';
            this.state.Filters.InitialMSCDuration = '';
            this.state.Filters.InitialHumidity = '';
            this.state.Filters.MSCSetpoint1 = '';
            this.state.Filters.MSCHumidity1 = '';
            this.state.Filters.MSCDuration1 = '';
            this.state.Filters.MSCSetpoint2 = '';
            this.state.Filters.MSCHumidity2 = '';
            this.state.Filters.MSCDuration2 = '';
        }
        else {
            this.setState({ cssPoint2Class: 'd-block' })
        }
        this.state.Filters.MSCSets = parseFloat(Value);
        this.setState({ Filters: filters });
    }

    MSCSetpoint1Change(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var MSCSetpoint1Val = this.state.Filters.MSCSetpoint1;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            MSCSetpoint1Val = Value;
        else
            return;
        this.state.Filters.MSCSetpoint1 = MSCSetpoint1Val;
        this.setState({ Filters: filters });
    }

    MSCHumiditySetpoint1Change(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var MSCHumidity1Val = this.state.Filters.MSCHumidity1;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            MSCHumidity1Val = Value;
        else
            return;
        this.state.Filters.MSCHumidity1 = MSCHumidity1Val;
        this.setState({ Filters: filters });
    }
    MSCHumiditySetpoint2Change(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var MSCHumidity2Val = this.state.Filters.MSCHumidity2;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            MSCHumidity2Val = Value;
        else
            return;
        this.state.Filters.MSCHumidity2 = MSCHumidity2Val;
        this.setState({ Filters: filters });
    }
    InitialTempChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var InitialTempVal = this.state.Filters.InitialTemp;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            InitialTempVal = Value;
        else
            return;
        this.state.Filters.InitialTemp = InitialTempVal;
        this.setState({ Filters: filters });
    }

    InitialHumidityChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var InitialHumidityVal = this.state.Filters.InitialHumidity;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            InitialHumidityVal = Value;
        else
            return;
        this.state.Filters.InitialHumidity = InitialHumidityVal;
        this.setState({ Filters: filters });
    }

    InitialMSCDurationChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var InitialMSCDurationVal = this.state.Filters.InitialMSCDuration;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            InitialMSCDurationVal = Value;
        else
            return;
        this.state.Filters.InitialMSCDuration = InitialMSCDurationVal;
        this.setState({ Filters: filters });
    }

    MSCDuration1Change(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var MSCDuration1Val = this.state.Filters.MSCDuration1;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            MSCDuration1Val = Value;
        else
            return;
        this.state.Filters.MSCDuration1 = MSCDuration1Val;
        this.setState({ Filters: filters });
    }

    MSCSetpoint2Change(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var MSCSetpoint2Val = this.state.Filters.MSCSetpoint2;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value))
            MSCSetpoint2Val = Value;
        else
            return;
        this.state.Filters.MSCSetpoint2 = MSCSetpoint2Val;
        this.setState({ Filters: filters });
    }

    MSCDuration2Change(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var MSCDuration2Val = this.state.Filters.MSCDuration2;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            MSCDuration2Val = Value;
        else
            return;
        this.state.Filters.MSCDuration2 = MSCDuration2Val;
        this.setState({ Filters: filters });
    }



    setDefaultFilters() {
        var filters: server.MSCParams = {
            MSCTurnONoFF: 'ON', MSCSets: 1, InitialTemp: '', InitialMSCDuration: '', InitialHumidity: '', MSCSetpoint1: '', MSCHumidity1: '', MSCDuration1: '', MSCSetpoint2: '', MSCHumidity2: '', MSCDuration2: ''
        };
        return filters;
    }


    ValidateNumberValue(param) {
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(param))
            return true;
        else
            return false;
    }

    ValidateDecimalValue(param) {
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(param))
            return true;
        else
            return false;
    }

    submitMSCCommand() {
        if (this.state.Filters.MSCTurnONoFF == "ON") {
            var AlertMessage = "";
            var MSCDuration1Value = this.state.Filters.MSCDuration1.toString();
            var MSCDuration2Value = this.state.Filters.MSCDuration2.toString();

            var InitialTempValue = this.state.Filters.InitialTemp.toString();

            var InitialMSCDurationValue = this.state.Filters.InitialMSCDuration.toString();
            var MSCSetpoint1Value = this.state.Filters.MSCSetpoint1.toString();
            var MSCSetpoint2Value = this.state.Filters.MSCSetpoint2.toString();
            var MSCInitialHumidityValue = this.state.Filters.InitialHumidity.toString();
            var MSCHumidity1Value = this.state.Filters.MSCHumidity1.toString();
            var MSCHumidity2Value = this.state.Filters.MSCHumidity2.toString();
            if (this.props.reeferData[0].ReeferOEMTypeCd.trim() == "C") {
                if ((!InitialTempValue || InitialTempValue == undefined || InitialTempValue == "" || InitialTempValue.length == 0) || !this.ValidateDecimalValue(InitialTempValue))
                    AlertMessage += "Please enter valid Initial Temp Setpoint value.\n";

                if ((!InitialMSCDurationValue || InitialMSCDurationValue == undefined || InitialMSCDurationValue == "" || InitialMSCDurationValue.length == 0) || !this.ValidateNumberValue(InitialMSCDurationValue))
                    AlertMessage += "Please enter valid Initial MSC Duration. \n";
                if ((!MSCDuration1Value || MSCDuration1Value == undefined || MSCDuration1Value == "" || MSCDuration1Value.length == 0) || !this.ValidateNumberValue(MSCDuration1Value))
                    AlertMessage += "Please enter valid MSC Duration1. \n";
                if ((!MSCSetpoint1Value || MSCSetpoint1Value == undefined || MSCSetpoint1Value == "" || MSCSetpoint1Value.length == 0) || !this.ValidateDecimalValue(MSCSetpoint1Value))
                    AlertMessage += "Please enter valid Temp Setpoint1 value.\n";
                if (this.state.Filters.MSCSets == 2) {
                    if ((!MSCSetpoint2Value || MSCSetpoint2Value == undefined || MSCSetpoint2Value == "" || MSCSetpoint2Value.length == 0) || !this.ValidateDecimalValue(MSCSetpoint2Value))
                        AlertMessage += "Please enter valid Temp Setpoint2 value.\n";
                    if ((!MSCDuration2Value || MSCDuration2Value == undefined || MSCDuration2Value == "" || MSCDuration2Value.length == 0) || !this.ValidateNumberValue(MSCDuration2Value))
                        AlertMessage += "Please enter valid MSC Duration2. \n";
                }
            }
            else if (this.props.reeferData[0].ReeferOEMTypeCd.trim() == "S") {
                if ((!MSCInitialHumidityValue || MSCInitialHumidityValue == undefined || MSCInitialHumidityValue == "" || MSCInitialHumidityValue.length == 0) || !this.ValidateNumberValue(MSCInitialHumidityValue))
                    AlertMessage += "Please enter valid Initial humidity value.\n";

                if ((!MSCHumidity1Value || MSCHumidity1Value == undefined || MSCHumidity1Value == "" || MSCHumidity1Value.length == 0) || !this.ValidateNumberValue(MSCHumidity1Value))
                    AlertMessage += "Please enter valid Humidity Setpoint1 value.\n";
                if (this.state.Filters.MSCSets == 2) {
                    if ((!MSCHumidity2Value || MSCHumidity2Value == undefined || MSCHumidity2Value == "" || MSCHumidity2Value.length == 0) || !this.ValidateNumberValue(MSCHumidity2Value))
                        AlertMessage += "Please enter valid Humidity Setpoint2 value.\n";

                }
            }

            //if (this.props.OEM == "S") {
            //    var MSCSetpoint1Value = this.state.Filters.MSCSetpoint1.toString();
            //    if ((!MSCSetpoint1Value || MSCSetpoint1Value == undefined || MSCSetpoint1Value == "" || MSCSetpoint1Value.length == 0) || !this.ValidateDecimalValue(MSCSetpoint1Value))
            //        AlertMessage += "Please enter valid final MSC temp value.\n";
            //    else if (this.state.Filters.MSCSetpoint1 <= this.state.Filters.MSCSetpoint2)
            //        AlertMessage += "Final MSC temp value should be greater than MSC set Point Value.\n";
            //}

            if (AlertMessage == '') {
                try {
                    var command = "MultipleSetpointChange";
                    var refreshGrid = this.props.refreshGrid;
                    var paramValue = this.state.Filters.MSCTurnONoFF.toString() + ',' + this.state.Filters.MSCSets.toString() + ',' + this.state.Filters.InitialTemp.toString() + ',' + this.state.Filters.InitialHumidity.toString() + ',' + this.state.Filters.InitialMSCDuration.toString() + ',' + this.state.Filters.MSCSetpoint1.toString() + ',' + this.state.Filters.MSCHumidity1.toString() + ',' + this.state.Filters.MSCDuration1.toString() + ',' + this.state.Filters.MSCSetpoint2.toString() + ',' + this.state.Filters.MSCHumidity2.toString() + ',' + this.state.Filters.MSCDuration2.toString();
                    this.submitTemperatureCommands(command, paramValue, refreshGrid);
                }
                catch (e) {
                    PopupWindow.showErrorMessage('Error', '');
                }
            }
            else {
                PopupWindow.showErrorMessage('Error', AlertMessage);
            }
        }
        else {
            try {
                var command = "MultipleSetpointChange";
                var refreshGrid = this.props.refreshGrid;
                var paramValue = this.state.Filters.MSCTurnONoFF.toString();
                this.submitTemperatureCommands(command, paramValue, refreshGrid);
            }
            catch (e) {
                PopupWindow.showErrorMessage('Error', AlertMessage);
            }
        }

    }

    submitTemperatureCommands(commandName, paramValue, refreshGrid) {
        if (self.state.RowData.length > 0) {
            self.state.ForwardCommandParms.CommandName = commandName;
            self.state.ForwardCommandParms.SelectedReefers = self.state.RowData;
            self.state.ForwardCommandParms.TempValue = paramValue;
            var forwardCommandParams = JSON.stringify(self.state.ForwardCommandParms);
            ReeferCommandsGrid.submitTemperatureCommands(commandName, paramValue, refreshGrid);
            self.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    public render() {
        return <div>
            <div className="modal-controls-container">

                <div className='row'>
                    <div className='col-lg-6'>
                        <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-4 col-xs-4 pe-0 text-md-end'>
                                <label className='col-form-label'>MSC Turn On/Off :</label>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-2 col-xs-2'>
                        <select className='form-select' id='MSCTurnONoFF' onChange={e => this.StatusONOFFChange(e)} value={this.state.Filters.MSCTurnONoFF}>
                            <option key="ON">ON</option>
                            <option key="OFF">OFF</option>
                        </select>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className={this.state.cssONOFFClass =='d-block' ? ' row' :this.state.cssONOFFClass}>
                        <div className='col-lg-6 col-md-6 col-sm-4 col-xs-4 pe-0 text-md-end'>
                                <label className='col-form-label'>No.of MSC Sets :</label>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-2 col-xs-2'>
                            <select className='form-select' id='MSCSets' onChange={e => this.StatusMSCSetsChange(e)} value={this.state.Filters.MSCSets}>
                                <option key="1">1</option>
                                <option key="2">2</option>
                            </select>
                        </div>
                    </div>
                    </div>
                </div>
                <div className={this.state.cssONOFFClass}>
                    <div className='row mt-6'>
                        <div className='col-lg-3 col-md-3 col-sm-4 col-xs-4 pe-0 text-md-end'>
                            <label className='col-form-label'>Initial Temp Setpoint :</label>
                        </div>
                        <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.InitialTempChange(e)} value={this.state.Filters.InitialTemp} /> </div>
                        <div className='col-lg-6 col-md-6'>
                            <div className={this.state.VisibleHumidity1}>
                                <div className='col-lg-8 col-md-8 pe-0 text-md-end'>
                                    <label className='col-form-label'>Initial Humidity Setpoint :</label>
                                </div>
                                <div className='col-lg-4 col-md-4'><input type='text' className='form-control' placeholder='' required onChange={e => this.InitialHumidityChange(e)} value={this.state.Filters.InitialHumidity} /> </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-6'>
                        <div className='col-lg-3 col-md-3 col-sm-4 col-xs-4 pe-0 text-md-end'>
                            <label className='col-form-label'>{MSCDurationInitialText}</label>
                        </div>
                        <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.InitialMSCDurationChange(e)} value={this.state.Filters.InitialMSCDuration} /> </div>
                    </div>
                    <div className='row mt-6'>
                        <div className='col-lg-3 col-md-3 col-sm-4 col-xs-4 pe-0 text-md-end'>
                            <label className='col-form-label'>Temp Setpoint 1 :</label>
                        </div>
                        <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.MSCSetpoint1Change(e)} value={this.state.Filters.MSCSetpoint1} /> </div>

                        <div className='col-lg-6 col-md-6'>
                            <div className={this.state.VisibleHumidity2}>
                                <div className='col-lg-8 col-md-8 pe-0 text-md-end'>
                                    <label className='col-form-label'>Humidity Setpoint 1 :</label>
                                </div>
                                <div className='col-lg-4 col-md-4'><input type='text' className='form-control' placeholder='' required onChange={e => this.MSCHumiditySetpoint1Change(e)} value={this.state.Filters.MSCHumidity1} /> </div>
                            </div>
                        </div>

                       
                    </div>
                    <div className='row mt-6'>
                        <div className='col-lg-3 col-md-3 col-sm-4 col-xs-4 pe-0 text-md-end'>
                            <label className='col-form-label'>{MSCDuration1Text}</label>
                        </div>
                        <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.MSCDuration1Change(e)} value={this.state.Filters.MSCDuration1} /> </div>
                    </div>
                    <div className={this.state.cssPoint2Class}>
                        <div className='row mt-6'>
                            <div className='col-lg-3 col-md-3 col-sm-4 col-xs-4 pe-0 text-md-end'>
                                <label className='col-form-label'>Temp Setpoint 2 :</label>
                            </div>
                            <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.MSCSetpoint2Change(e)} value={this.state.Filters.MSCSetpoint2} /> </div>
                            <div className={this.state.VisibleHumidity3}>
                                <div className='col-lg-4 col-md-4 col-sm-4 col-xs-4'>
                                    <label className='col-form-label'>Humidity Setpoint 2 :</label>
                                </div>
                                <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.MSCHumiditySetpoint2Change(e)} value={this.state.Filters.MSCHumidity2} /> </div>
                            </div>
                        </div>
                        <div className='row mt-6'>
                            <div className='col-lg-3 col-md-3 col-sm-4 col-xs-4 pe-0 text-md-end'>
                                <label className='col-form-label'>{MSCDuration2Text}</label>
                            </div>
                            <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2'><input type='text' className='form-control' placeholder='' required onChange={e => this.MSCDuration2Change(e)} value={this.state.Filters.MSCDuration2} /> </div>
                        </div>
                    </div>
                </div>

            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} formName='MultipleSetPoints' selectedReefers={this.state.RowData} commandName={"MultipleSetpointChange"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitMSCCommand.bind(this)}>Save</button>
            </div>
        </div>
    }
}